import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface TableStoreProps<T> {
	pageState: any;
	setPageState: (pageState: any) => void;
	clearSelectedRows?: (bool: boolean) => void;
	setClearSelectedRowsCallback: (callback: any) => void;
}

const useTableStore = create<TableStoreProps<any>>()(
	devtools(
		(set) => ({
			pageState: {} as any,
			clearSelectedRows: undefined,

			setPageState: (pageState: any) => set({ pageState }),
			setClearSelectedRowsCallback: (callback) =>
				set({ clearSelectedRows: callback }),
		}),
		{ name: 'TableStore' }
	)
);

export default useTableStore;
